<template>
  <div class="usePageBox">
    <div v-if="true" class="topBox">
      <div class="leftBox">
        <AutoComplete size="large" placeholder="输入商品名搜索" icon="ios-search" clearable @on-search="searchSkuNameCallback"
                      @on-select="selectSkuNameCallback">
          <Option v-for="item in searchSkuList" :value="item.sku_name" :key="item.sku_id"> {{item.sku_name}}</Option>
        </AutoComplete>
      </div>
      <div class="rightBox">
        <div>
          <RadioGroup type="button" size="large" v-model="searchParams.packStatus"
                      @on-change="changeStatusCallback">
            <Radio :label="0">全部</Radio>
            <Radio :label="1" style="background-color: #669933;color: #F0F0F0">待分拣</Radio>
            <Radio :label="3" style="background-color: #666666;color: #F0F0F0">缺货</Radio>
            <Radio :label="2" style="background-color: #6699CC;color: #F0F0F0">已分拣</Radio>
          </RadioGroup>
          <span>图片分拣</span>
          <i-switch size="large" v-model="openPic" @on-change="changeOpenSkuCover">
            <span slot="open">开</span>
            <span slot="close">关</span>
          </i-switch>
        </div>
        <div>
          <span style="right: 0px;">
              <a @click="showSearch">更多筛选<Icon type="ios-arrow-forward" /></a>
          </span>
        </div>
      </div>
    </div>
    <div v-if="true" class="contentBox">
      <div class="leftBox">
        <div class="skuBoxArea" style="width:240px;height:100%;overflow:hidden; overflow-y:scroll;background:white">
          <div class="skuBox">
            <div @click="toSelect(item)" :class="currentSku.groupSkuId==item.groupSkuId?'active':''"
                 v-for="(item,index) in skuList" :key="item.id" class="skuItem">
              <div class="textBox" style="font-size:20px" :id="'text' + item.sku_id">
                {{ item.sku_name ? item.sku_name : item.product_name }}
                <div class="countNum" v-if="item.wait_count > 0">
                  <div class="numtext">{{ item.wait_count }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <Row>
          <Col style="height:78vh;" :flex="1">
            <Spin fix v-if="loading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load" />
              <div>Loading</div>
            </Spin>
            <batchNumberModel @callBackData="callBackData" :batchCountObj="batchCountObj" ref="batchNumberRef" />
            <!-- 溯源-分拣绑定入库批次 -->
            <!-- <span v-for="(item, index) in skuBatchNoList"
                  v-if="packDatas.length && $store.state.platform_setting.moduleArr.includes('traceSource')">
  <span>{{ item.skuName }}</span>&nbsp;
  <Select style="width:200px" v-model="batchNoSelect[index]" size="large">
      <Option v-for="(itema,i) in item.batch_nos" :value="itema" :key="i"><span>{{ itema }}</span></Option>
  </Select>
</span> -->
            <Row :gutter="20" v-if="!loading">
              <Col :sm="24" :md="12" :lg="12" :xl="8" :xxl="8" v-for="(item,index) in packDatas" :key="item.id"
                   style="margin-top: 40px;">
                <div style="line-height: 40px">
                  路线：{{ item.lineTitle ? item.lineTitle : "无路线" }}
                  <span v-if="sortingNoData.noLine">
                    <!--<span v-if="searchParams.lineId">{{sortingNoData[searchParams.lineId][item.id]}}</span>-->
                    <span v-if="item.lineId && sortingNoData[item.lineId]">{{sortingNoData[item.lineId][item.id]}}</span>
                    <span v-else>{{sortingNoData.noLine[item.id]}}</span>
                  </span>
                </div>
                <div class="areaBox">
                  <div class="cardLeft" :style="{'background-color': getBackgroundColor(item)}"
                       @click="changeSortingData(item)">
                    <div style="margin:7px;">
                      <Badge :count="index+1" />
                      <span v-if="item.delivery_type==4">
												{{item.deliver_user_name}}
												<span v-if="item.buyer && item.buyer.reciver_name">({{item.buyer.reciver_name}})</span>
											</span>
                      <span v-else>{{item.deliver_user_name}}</span>
                    </div>
                    <div style="text-align: center;">
                      <b style="line-height: 40px;"
                         :style="{fontSize:(item.product_num.toString().length>3?'28px':item.product_num.toString().length>2?'32px':'37px')}">
                        {{item.showUnit}}
                      </b>
                      <p v-if="item.realWeight && flush">(拣出:{{ item.showSortingUnit }})</p>
                      <p v-if="item.lack_status==2" style="color: #fb4747">(缺货)</p>
                    </div>
                    <div style="margin:7px;font-size: 14px;">
                      备注：{{ item.order_note }}
                    </div>
                  </div>
                  <div class="cardRight mycardRight">
                    <Button class="top" @click="showKeyboard(item,index)" :disabled="item.lack_status==2 || item.status>61">
                      <b>输入</b>
                    </Button>
                    <Poptip class="top" placement="right">
                      <Button class="buttom">
                        <b>操作</b>
                      </Button>
                      <div slot="content">
                        <ButtonGroup vertical size="large">
                          <Button :disabled="item.status==CONSTANT.DELIVER_STATE_KEY.PACK_NO" @click="printData(item,1)">
                            打印标签
                          </Button>
                          <Button :disabled="item.lack_status==2 || item.status>CONSTANT.DELIVER_STATE_KEY.PACK_NO"
                                  @click="editSortingLackStatus(item)"
                                  v-if="item.lack_status==1">
                            标记缺货
                          </Button>
                          <Button @click="editSortingLackStatus(item)" v-if="item.lack_status==2">
                            标记有货
                          </Button>
                          <Button @click="doWholeBox(item)"
                                  v-if="$store.state.softwareSetting.openBox == 1 && !item.packingBoxCount &&
																					item.packing_type==2">
                            整件装箱
                          </Button>
                          <Button @click="cancelBox(item)"
                                  v-if="$store.state.softwareSetting.openBox == 1 && item.packingBoxCount">
                            取消装箱
                          </Button>
                        </ButtonGroup>
                      </div>
                    </Poptip>
                  </div>
                </div>
                <a v-if="item.packingBoxCount">已装{{item.packingBoxCount}}箱</a>
                <sortingTurnbox :sortingData="item" />
              </Col>
            </Row>
            <div style="height: 50px;" />
          </Col>
        </Row>
      </div>
    </div>
    <search ref="search" :searchParams="searchParams" :carLine="carLine" @reciveSearchData="reciveSearchData" />
    <keyboard ref="keyboard" @reciveData="reciveKeyboardData" :canDecimal="false" />
    <weightReading :unit="'份'" :showWeight="false" ref="weightReading"/>
    <picModal v-if="openPic" ref="picModal" :skuId="currentSku.groupSkuId" />
    <div id="qrcode" v-show="false" />
    <!--条形码-->
    <img id="jsbarcode" v-show="false" />
    <cancelBox ref="cancelBox" @cancelBoxSubmit="cancelBoxSubmitCallback" />
    <globalPrint ref="globalPrint" />
    <Modal v-model="showWarningBox" width="500">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle" />
        <span>分拣提示</span>
      </p>
      <div style="display:flex;align-items:center;justify-content: center; height:200px;">
        <p>{{signText}}</p>
      </div>
      <div slot="footer">
        <div class="footerButton" @click="showWarningBox=false">取消分拣</div>
        <div class="footerButton waring" @click="toStillDo">继续分拣</div>
        <div class="footerButton success" v-if="signType==1" @click="toChangeDo()">切换批次分拣</div>
        <div class="footerButton success" v-if="signType==2" @click="toChooseNoneDo">无批次分拣</div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import config from '@/config'

  const h5PageUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.h5PageDev : config.baseUrl.h5PagePro;
  const CONSTANT = require("../../../common/const");
  const timeUtil = require("@/libs/timeUtil");
  const qrcode = require("qrcodejs2");
  const JsBarcode = require("jsbarcode");
  import keyboard from "_c/keyboard";
  import weightReading from "_c/weightReading";
  import batchNumberModel from "_c/batchNumberModel"
  import sortingTurnbox from "_c/sortingTurnbox/sortingTurnbox";
  import picModal from "_c/picModal";
  import {
    querySortingSku,
    querySortingBySku,
    queryCarLine,
    editSortingStandard,
    editSortingLackStatus,
    getPrintTemplate,
    initSortingNo, getSortingDataById
  } from '@/api/sorting/sorting'
  import { getBackgroundColor } from '@/libs/tools'
  // import { printByTemplate } from "../../util/countUtil";
  import { getUnitAndBaseUnit, getHasSortingUnitAndBaseUnit } from "@/libs/util";
  // import {add, reduce, mul, div} from "../../util/NumberUtil";
  import { printByTemplate, printByTemplateV2 } from "../../util/printUtil";
  // 溯源-非标品/标品拣货台-SPU—SKU—入库批次号查询
  import { doPackingBoxByPackIds } from "@/api/sorting/packingBox";

  export default {
    name: 'weightSorting',
    components: { keyboard, weightReading, picModal, sortingTurnbox, batchNumberModel },
    data() {
      return {
        nowIndex: '',
        nowBatch_no: '',
        canUseBatchs: [],
        realCanDo: false,
        showWarningBox: false,
        signText: '',
        signType: 1,
        batchCountObj: {},
        flush: true, // 处理数据不刷新
        CONSTANT,
        getBackgroundColor: getBackgroundColor,
        workbenchId: 0, // 工作台id
        loading: true,
        // 分拣sku列表
        skuList: [],
        // 当前选中sku
        // currentSkuId: null,
        currentSku: {},
        // 检索sku列表
        searchSkuList: [],
        // 当前选择分拣数据
        currentSortingData: {},
        // 查询参数
        searchParams: {
          // title: "",
          lineId: null,
          packStatus: 0,
          isWeight: 2,
          skuGroupType: this.$store.state.softwareSetting.skuGroupType,
          // sort: this.$store.state.softwareSetting.sortingMoved,
          distributor: null,
          supplierId: null,
          packingType: null,
          dateType: this.$store.state.dateType
        },
        // 拣货数据
        packDatas: [],
        // 开启图片分拣
        openPic: false,
        // 配送路线
        carLine: [],
        // 当前电子秤读数、输入数量
        currentWeightData: 0,
        // 小票模板
        printTemplate: {},
        // 溯源-分拣绑定入库批次
        skuBatchNoList: [], // sku列表，数据结构:[{skuId,batch_nos:批次号数组}]
        batchNoSelect: [],  // 当前选择批次数组，与sku一一对应
        sortingNoData: {}, // 分拣序号数据
      }
    },
    methods: {
      callBackData(data) {
        this.batchNoSelect = data.batchNoSelect;
        this.skuBatchNoList = data.skuBatchNoList;
      },
      // 打开筛选窗口
      showSearch() {
        this.$refs.search.showSearchModal();
      },
      reciveSearchData(data) {
        this.querySortingSku();
      },
      // 选择sku
      toSelect(item) {
        // this.currentSkuId = item.groupSkuId;
        this.currentSku = item;
        this.querySortingBySku();
        this.openPicModal();
      },
      // 打开数字键盘
      showKeyboard(data) {
        this.currentSortingData = data;
        this.$refs.keyboard.showKeyboardModal(data);
      },
      // 刷新待分拣数量
      reflushWaitSortingCount() {
        let count = 0;
        for (let i = 0; i < this.packDatas.length; i++) {
          if (this.packDatas[i].status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
            count++;
          }
        }
        this.currentSku.wait_count = count;
        // 整件自动装箱
        if (this.$store.state.softwareSetting.openBox == 1 && this.$store.state.softwareSetting.autoWholeBox == 1) {
          this.flushPackingBox([this.currentSortingData.id]);
        }
      },
      // 查询sku
      querySortingSku() {
        return new Promise((resolve, reject) => {
          let param = { ...this.searchParams };
          param.packTime = [this.$store.state.sortingTimeSetting.sortingStartTime, this.$store.state.sortingTimeSetting.sortingEndTime];
          param.spuCategoryIds = this.$store.state.sortingTimeSetting.spuCategoryIds;
          querySortingSku(param).then(res => {
            if (res.status === 200) {
              this.skuList = res.data.data.rows;
              this.workbenchId = res.data.data.workbenchId;
              this.searchParams.platform_types = res.data.data.platform_types;
              if (this.skuList.length) {
                this.currentSku = this.skuList[0];
                this.openPicModal();
                // this.queyPackWithId(this.currentSkuId);
              }
              this.querySortingBySku();
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 查询sku拣货数据
      querySortingBySku() {
        this.searchParams.groupSkuId = this.currentSku.groupSkuId;
        this.searchParams.packTime = [this.$store.state.sortingTimeSetting.sortingStartTime, this.$store.state.sortingTimeSetting.sortingEndTime];
        this.searchParams.spuCategoryIds = this.$store.state.sortingTimeSetting.spuCategoryIds;
        this.searchParams.sort = this.$store.state.softwareSetting.sortingMoved;
        return new Promise((resolve, reject) => {
          this.loading = true;
          querySortingBySku(this.searchParams).then(res => {
            if (res.status === 200) {
              this.packDatas = res.data.data.datas;
              // 添加showExtend数据
              if (res.data.data.datas && res.data.data.datas.length) {
                res.data.data.datas.forEach(item => {
                  item.showExtend = JSON.parse(JSON.stringify(item.extend));
                })
              }
              // 拼接路线
              let waitCount = 0; // 当前sku分拣数据量
              for (let i = 0; i < this.packDatas.length; i++) {
                // 应分拣数量 箱|10斤
                let base_unit = this.packDatas[i].base_unit, unit = this.packDatas[i].product_cache.specifications,
                  unit_conversion = this.packDatas[i].unit_conversion, is_weight = this.packDatas[i].is_weight;
                if (this.packDatas[i].extend) {
                  this.packDatas[i].realWeight = this.packDatas[i].extend.weight;
                  let showUnitData = getHasSortingUnitAndBaseUnit({
                    base_unit,
                    weightG: this.packDatas[i].extend.weight,
                    unit,
                    unit_conversion,
                    is_weight
                  });
                  this.packDatas[i].showSortingUnit = showUnitData.showUnit;
                }
                if (!this.packDatas[i].product_cache) {
                  // 兼容旧数据
                  this.packDatas[i].product_cache = {};
                }

                if (!this.packDatas[i].product_cache.specifications)
                  this.packDatas[i].product_cache.specifications = "份";

                let num = this.packDatas[i].product_num;
                let showUnitData = getUnitAndBaseUnit({ base_unit, unit, num, unit_conversion, is_weight });
                this.packDatas[i].showUnit = showUnitData.showUnit;

                for (let j = 0; j < this.carLine.length; j++) {
                  if (this.carLine[j].grouper_ids) {
                    if (this.carLine[j].grouper_ids.includes(this.packDatas[i].deliver_user)) {
                      this.packDatas[i].lineTitle = this.carLine[j].title;
                      this.packDatas[i].lineId = this.carLine[j].id;
                    }
                  }
                }
                // if (this.packDatas[i].status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
                waitCount++;
                // }
              }
              if (waitCount > this.currentSku.count)
                this.currentSku.count = waitCount;
              this.loading = false;

              // 溯源-分拣绑定入库批次
              if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("traceSource")) {
                this.$refs.batchNumberRef.querySkuBatchNos(this.searchParams.groupSkuId)
              }
              if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("sortingNo")) {
                this.initSortingNo();
              }
              this.countBatchCount()
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 查询配送路线
      queryCarLine() {
        return new Promise((resolve, reject) => {
          queryCarLine().then(res => {
            if (res.status === 200) {
              this.carLine = res.data.data;
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 获取分拣序号
      initSortingNo() {
        return new Promise((resolve, reject) => {
          initSortingNo(this.searchParams).then(res => {
            if (res.status === 200) {
              this.sortingNoData = res.data.data;
              // 添加分拣序号
              if (this.sortingNoData.noLine) {
                for (let i = 0; i < this.packDatas.length; i++) {
                  let sortingNo = this.sortingNoData.noLine[this.packDatas[i].id];
                  if (this.packDatas[i].lineId && this.sortingNoData[this.packDatas[i].lineId]) {
                    sortingNo = this.sortingNoData[this.packDatas[i].lineId][this.packDatas[i].id];
                  }
                  if (this.searchParams.lineId && this.sortingNoData[this.searchParams.lineId]) {
                    sortingNo = this.sortingNoData[this.searchParams.lineId][this.packDatas[i].id];
                  }

                  // this.packDatas[i].sortingNo = sortingNo;
                  this.$set(this.packDatas[i], "sortingNo", sortingNo);
                  // console.log(sortingNo)
                }
              }
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 选择路线回调查询
      changeCarCallback(event) {
        if (!event) {
          delete this.searchParams.grouper_ids;
          return this.querySortingBySku();
        }
        let grouper_ids = [];
        for (let i = 0; i < this.carLine.length; i++) {
          if (event == this.carLine[i].id) {
            grouper_ids = this.carLine[i].grouper_ids;
          }
        }
        this.searchParams.grouper_ids = grouper_ids;
        this.querySortingBySku();
      },
      // 接收称重数据
      /*reciveData(data) {
          this.currentWeightData = Number(data.data);
      },*/
      // 接收数字键盘数据
      reciveKeyboardData(data) {
        // this.currentWeightData = Number(data.data);
        let number = Number(data.data);
        this.changeSortingData(this.currentSortingData, number);
      },
      // 选择分拣数据 更新称重
      changeSortingData(data, number) {
        // keyboardCakkback 是否是键盘输入回调，是的话需要重新
        if (data.lack_status == 2) {
          return;
        }
        this.currentSortingData = data;
        // console.log(number)
        // console.log(this.currentSortingData)
        // console.log(this.currentWeightData)
        if (!number) {
          this.currentWeightData = this.currentSortingData.product_num;
          // 分拣过的实际数量
          if (this.currentSortingData.hasOwnProperty("realWeight"))
            this.currentWeightData = this.currentSortingData.realWeight;

          this.currentSortingData.realWeight = this.currentWeightData;
        } else {
          this.currentWeightData = number;
          this.currentSortingData.realWeight = number;
        }

        // 已打包状态只打印标签
        if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_COMPLETE) {
          // console.log("打印标签");
          return this.printData(this.currentSortingData);
        }
        // 如果没有录入检出量并且未分拣，默认拣出购买量
        if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
          let unit = this.currentSortingData.product_cache.specifications;
          this.currentSortingData.extend = {
            weight: this.currentSortingData.product_num,
            unit
          };
          if (!this.currentSortingData.showExtend) {
            this.currentSortingData.showExtend = { weight: this.currentSortingData.product_num, unit: 'g' };
          } else {
            this.currentSortingData.showExtend.weight = this.currentSortingData.product_num;
          }
          // let oldRealWeight = 0; // 记录旧数据，取消后还原
          /*this.$Modal.confirm({
              title: "拣出" + (this.currentSortingData.realWeight) + unit + "，是否继续分拣",
              content:
                  "<p></p>",
              onOk: () => {
                  this.flushSortingData();
              },
              onCancel: () => {
                  delete this.currentSortingData.realWeight;
              }
          });*/
          this.flushSortingData();
        } else if (this.currentWeightData == this.currentSortingData.extend.weight) {
          if (!this.currentSortingData.showExtend) {
            this.currentSortingData.showExtend = { weight: this.currentWeightData, unit: 'g' };
          } else {
            this.currentSortingData.showExtend.weight = this.currentWeightData;
          }
          // 已分拣并且再次点击拣出数量没有变的情况下只打印标签
          // console.log("打印标签");
          // console.log(this.currentSortingData)
          // console.log(this.currentWeightData)
          // return this.printData(this.currentSortingData);
          this.flushSortingData();
        } else {
          if (!this.currentSortingData.showExtend) {
            this.currentSortingData.showExtend = { weight: this.currentWeightData, unit: 'g' };
          } else {
            this.currentSortingData.showExtend.weight = this.currentWeightData;
          }
          this.flushSortingData();
        }
      },
      // 刷新并提交分拣
      flushSortingData() {
        this.flush = false;
        this.currentSortingData.realWeight = this.currentWeightData;
        // this.currentSortingData.product_num = this.currentWeightData;
        this.flush = true;
        // TODO 此处检测库存信息
        if (!this.judgeBatchStoreNumer()) {
          if (!this.realCanDo) {
            return
          }
        }
        this.realCanDo = false;

        let base_unit = this.currentSortingData.base_unit, unit = this.currentSortingData.product_cache.specifications,
          unit_conversion = this.currentSortingData.unit_conversion, is_weight = this.currentSortingData.is_weight;
        let showUnitData = getHasSortingUnitAndBaseUnit({
          base_unit,
          weightG: this.currentWeightData,
          unit,
          unit_conversion,
          is_weight
        });
        this.currentSortingData.showSortingUnit = showUnitData.showUnit;

        // 已打包配送的不更新，只打印标签
        if (this.currentSortingData.status != CONSTANT.DELIVER_STATE_KEY.PACK_COMPLETE) {
          this.editSortingStandard();
          // this.currentWeightData = 0;
        }
        // 首次分拣后移
        if (this.$store.state.softwareSetting.sortingMoved == 1) {
          if (this.currentSortingData.status == CONSTANT.DELIVER_STATE_KEY.PACK_NO) {
            let index;
            for (let i = 0; i < this.packDatas.length; i++) {
              if (this.currentSortingData.id == this.packDatas[i].id) {
                index = i;
              }
            }
            if (index >= 0) {
              this.packDatas.splice(index, 1);
              this.packDatas.push(this.currentSortingData);
            }
          }
        }
      },
      // 判断批次库存是否足够
      judgeBatchStoreNumer() {
        let that = this;
        let canDo = true;
        let realWeight = that.currentSortingData.realWeight;
        let batch_no = '';
        let batch_number = 0;
        let canUseBatchs = [];
        let nowIndex = '';
        for (let i = 0; i < this.skuBatchNoList.length; i++) {
          if (this.skuBatchNoList[i].skuId == this.currentSortingData.sku_id) {
            batch_no = this.batchNoSelect[i];
            for (let k = 0; k < this.skuBatchNoList[i].batch_nos.length; k++) {
              let hadUseNum = that.batchCountObj[this.skuBatchNoList[i].batch_nos[k].batch_no] ? that.batchCountObj[this.skuBatchNoList[i].batch_nos[k].batch_no] : 0;
              let nowNumber = this.skuBatchNoList[i].batch_nos[k].number;
              let canUseNum = nowNumber - hadUseNum;
              if (realWeight <= canUseNum) {
                canUseBatchs.push({ index: i, batch_no: this.skuBatchNoList[i].batch_nos[k].batch_no });
              }
              if (this.skuBatchNoList[i].batch_nos[k].batch_no == batch_no) {
                batch_number = this.skuBatchNoList[i].batch_nos[k].number;
                nowIndex = i;
              }
            }
          }
        }
        this.canUseBatchs = canUseBatchs;
        // 存下批次分拣
        if (batch_no) {
          // 判断本批次的库存是否足够
          let hadUseNum = that.batchCountObj[batch_no] ? that.batchCountObj[batch_no] : 0;
          let canUseNum = batch_number - hadUseNum;
          if (realWeight > canUseNum) {
            this.nowIndex = nowIndex;
            this.nowBatch_no = batch_no;
            canDo = false;
            if (!this.realCanDo) {
              this.showWarningBox = true;
            }
            // 提示是否切换库存分拣
            if (canUseBatchs.length < 1) {
              this.signType = 2;
              this.signText = "当前商品暂无任何批次的剩余库存数量满足本次分拣数量";
            } else {
              this.signType = 1;
              this.signText = "当前批次剩余库存数量无法本次分拣数量";
            }
          }
        }
        return canDo;
      },
      // 本批次依然分拣
      toStillDo() {
        this.realCanDo = true;
        this.showWarningBox = false;
        this.flushSortingData();
      },
      // 切换批次分拣
      toChangeDo(value) {
        this.$refs.batchNumberRef.toSelectSkuNumber(this.canUseBatchs[0].batch_no, this.canUseBatchs[0].index);
        if (value) {
          return
        }
        this.realCanDo = true;
        this.showWarningBox = false;
        this.flushSortingData()
      },
      // 无批次分拣
      toChooseNoneDo() {
        this.$refs.batchNumberRef.toSelectSkuNumber(this.nowBatch_no, this.nowIndex);
        this.realCanDo = true;
        this.showWarningBox = false;
        this.flushSortingData()
      },
      // 更新分拣数据
      editSortingStandard() {
        return new Promise((resolve, reject) => {
          let realWeight = this.currentSortingData.realWeight;
          let realCount = JSON.parse(JSON.stringify(realWeight));
          // realWeight = changeUnit(realWeight, "斤", "g");
          let param = {
            id: this.currentSortingData.id,
            workbenchId: this.workbenchId,
            realWeight
          };
          for (let i = 0; i < this.skuBatchNoList.length; i++) {
            if (this.skuBatchNoList[i].skuId == this.currentSortingData.sku_id) {
              param.batch_no = this.batchNoSelect[i];
            }
          }
          // 添加称重框参数
          if (this.$store.state.boxSetting && this.$store.state.boxSetting.selectBoxList.length) {
            param.boxSetting = this.$store.state.boxSetting;
          }
          // 整件自动装箱
          if (this.$store.state.softwareSetting.openBox == 1) {
            param.autoWholeBox = this.$store.state.softwareSetting.autoWholeBox;
          }
          editSortingStandard(param).then(data => {
            if (data.data.code === 1200) {
              // 更新可分拣数量
              this.currentSortingData.status = CONSTANT.DELIVER_STATE_KEY.PACK_WATI;
              this.currentSortingData.real_count = realCount;
              if (param.batch_no) {
                this.currentSortingData.batch_no = param.batch_no;
              }
              if (this.$store.state.boxSetting && this.$store.state.boxSetting.autoLent == "true" && this.$store.state.boxSetting.selectBoxList && this.$store.state.boxSetting.selectBoxList.length) {
                let boxTitles = "";
                for (let i = 0; i < this.$store.state.boxSetting.selectBoxList.length; i++) {
                  boxTitles += this.$store.state.allTurnoverBoxsObj[this.$store.state.boxSetting.selectBoxList[i].id].title + "*" + this.$store.state.boxSetting.selectBoxList[i].count + " "
                }
                this.currentSortingData.boxTitles = boxTitles;
              }
              this.reflushWaitSortingCount();
              this.printData(this.currentSortingData);
              this.countBatchCount()
            } else {
              this.$Notice.error({ title: "分拣异常", desc: data.data.msg });
              // this.querySortingBySku();
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 标记、取消标记缺货
      editSortingLackStatus(sortingData) {
        this.currentSortingData = sortingData;
        return new Promise((resolve, reject) => {
          let lackStatus = 2;
          if (sortingData.lack_status == 2)
            lackStatus = 1;
          let param = {
            id: this.currentSortingData.id,
            lackStatus,
          };
          this.currentSortingData.lack_status = lackStatus;
          editSortingLackStatus(param).then(data => {
            if (data.data.code === 1200) {
              this.$Notice.success({
                title: "标记成功",
              })
            }
          });
        }).catch(err => {
          console.log(err);
          this.$Message.error(err);
        });
      },
      // 整件装箱
      doWholeBox(event) {
        this.currentSortingData = event;
        this.$Modal.confirm({
          title: "提示",
          content: "商品为整件装箱，根据拣出数生成箱子，如拣出数为2，则生成2个箱子，若拣出数为2.1，则生成3个箱子",
          onOk: () => {
            doPackingBoxByPackIds({ packIds: [this.currentSortingData.id] }).then(data => {
              if (data.data.code === 1200) {
                this.flushPackingBox([this.currentSortingData.id]);
              }
            }).catch(err => {
              this.$Message.error(err);
            });
          },
          onCancel: () => {
          }
        });
      },
      // 取消装箱
      cancelBox(item) {
        this.currentSortingData = item;
        this.$refs["cancelBox"].queryPackingBoxList(item);
      },
      // 取消装箱回调
      cancelBoxSubmitCallback() {
        this.flushPackingBox([this.currentSortingData.id]);
      },
      // 刷新分拣数据箱子
      flushPackingBox(packIds) {
        setTimeout(() => {
          for (let j = 0; j < packIds.length; j++) {
            let currentIndex = 0;
            for (let i = 0; i < this.packDatas.length; i++) {
              if (this.packDatas[i].id == packIds[j]) {
                this.packDatas[i]._checked = 0;
                currentIndex = i;
              }
            }
            getSortingDataById({ id: packIds[j] }).then(data => {
              if (data.data.code === 1200) {
                this.packDatas[currentIndex].packingBoxCount = data.data.data.packingBoxCount;
                let boxIds = data.data.data.boxIds;
                // 整件自动装箱 打印箱签
                if (this.$store.state.softwareSetting.openBox == 1 && this.$store.state.softwareSetting.autoPrintBoxLabel == 1
                  && this.packDatas[currentIndex].packing_type == 2) {
                  for (let boxId of boxIds) {
                    this.$refs.globalPrint.printPackingBox([{
                      orderId: this.packDatas[currentIndex].order_id,
                      boxId: boxId
                    }]);
                  }
                }
              }
            })
          }
        }, 300);
      },
      // 打印单个
      printData(data, autoPrint) {
        if (!autoPrint) {
          // 判断是否打印标签
          if (this.$store.state.softwareSetting.autoPrint == "2") {
            return;
          }
        }
        // 是否生成溯源码
        let imgBase64, qr, barcodeBase64;
        if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("traceSource")) {
          document.getElementById("qrcode").innerHTML = "";
          qr = new qrcode("qrcode", {
            text: h5PageUrl + "/s/#/?s=" + data.id,
            width: 80,
            height: 80,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: qrcode.CorrectLevel.L
          });
        }
        document.getElementById("jsbarcode").setAttribute("src", "");
        JsBarcode("#jsbarcode", data.id, { displayValue: false });
        barcodeBase64 = document.getElementById("jsbarcode").getAttribute("src");
        setTimeout(() => {
          let product = JSON.parse(JSON.stringify(data));
          if (qr) {
            imgBase64 = qr._oDrawing._elImage.src;
          }
          if (product) {
            product.barcode = barcodeBase64;
            product.sourceCode = imgBase64 ? imgBase64 : "";
            product.sku_name = product.product_name;
            // 分拣员
            if (this.$store.state.user && this.$store.state.user.userInfo) {
              product.sorterName = this.$store.state.user.userInfo.name || this.$store.state.user.userInfo.nick;
            }
            // 收货人
            if (product.buyer && product.buyer.reciver_name) {
              product.name = product.buyer.reciver_name;
              product.reciver_phone = product.buyer.reciver_phone;
            }
            /*if (product.extend && product.extend.weight && product.extend.unit) {
                product.sort_number = product.extend.weight + product.extend.unit;
            } else {*/
            product.sort_number = product.realWeight + product.product_cache.specifications;
            product.sort_number_new = product.showSortingUnit;
            product.product_num_new = product.showUnit;
            if (product.sortingNo) {
              product.lineTitle += "-" + product.sortingNo;
            }
            console.log(product);
            product.specifications = product.product_cache ? product.product_cache.specifications : "";
            product.sku_goods_code = product.sku_goods_code;
            product.sku_goods_code_text = product.sku_goods_code;
            product.printTime = timeUtil.dateFormat(timeUtil.getFullDate(), "YYYY/MM/DD HH:mm");
            if (this.printTemplate.template_grade == 2) { // 新版打印
              product.barcode = data.id;
              printByTemplateV2(this.printTemplate.printTemplate, [product], this.printTemplate.printIndex);
            } else {
              printByTemplate(product.id + "sorting", 1, this.printTemplate.printIndex, product, this.printTemplate,);
            }
          } else {
            this.$Message.error("当前没有分拣单");
          }
        }, 100);
      },
      // 查询打印模板信息
      getPrintTemplate() {
        let param = { type: 1 };
        // 判断是否绑定模板
        let printInfo = localStorage.getItem("printSet");
        if (printInfo) {
          let printData = JSON.parse(printInfo);
          if (printData.fenjianPrintTemplate) {
            param.id = printData.fenjianPrintTemplate
          }
        }
        getPrintTemplate(param).then(data => {
          if (data.data.code == 1200) {
            if (!data.data.data) {
              console.log("拣货模板", data.data.data);
              return this.$Notice.warning({
                title: "",
                duration: 0,
                render: h => {
                  return h('span', {
                      style: { "font-size": "22px", "margin-left": "10px", "line-height": "28px" }
                    },
                    ['未检测到分拣小票打印模板，',
                      h('a', {
                        style: { "font-size": "22px" },
                        props: { type: 'success', size: 'small' },
                        on: {
                          click: () => {
                            this.$Notice.destroy();
                            this.$router.push({ name: 'setting' });
                          }
                        }
                      }, '点击'),
                      '前往设置模版'
                    ])
                }
              });
            }
            this.printTemplate = {
              page: data.data.data.page,
              type: data.data.data.type,
              printTemplate: data.data.data.print_template,
              template_grade: data.data.data.template_grade
            };
            // 获取打印机索引
            let printInfoSe = localStorage.getItem("printSet");
            if (printInfoSe) {
              printInfoSe = JSON.parse(printInfoSe);
              this.printTemplate.printIndex = printInfoSe.fenjianPrint;
            }
          }
        })
      },
      // 名称查询
      /*changeTitleCallback(event) {
          this.querySortingBySku();
      },*/
      // 状态查询
      changeStatusCallback() {
        this.querySortingBySku();
      },
      // 开启图片拣货
      changeOpenSkuCover(event) {
        localStorage.setItem("openPic", event);
        this.openPicModal();
      },
      openPicModal() {
        if (this.openPic) {
          setTimeout(() => {
            this.$refs.picModal.showCover(this.currentSku.groupSkuId);
          }, 300);
        }
      },
      // 检索sku名称
      searchSkuNameCallback(value) {
        this.searchSkuList = [];
        for (let i = 0; i < this.skuList.length; i++) {
          if (this.skuList[i].sku_name.includes(value)) {
            this.searchSkuList.push(this.skuList[i]);
          }
        }
      },
      // 选中检索sku
      selectSkuNameCallback(event) {
        for (let i = 0; i < this.searchSkuList.length; i++) {
          if (event == this.searchSkuList[i].sku_name) {
            this.currentSku = this.searchSkuList[i];
             document.getElementById('text' + this.searchSkuList[i].sku_id).scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
            this.querySortingBySku();
            this.openPicModal();
          }
        }
      },
      // 配送方查询回调
      changeDistributorCallback(event) {
        this.searchParams.distributor = event;
        this.querySortingSku();
      },
      // 选择供应商回调
      changeSupplierCallback(event) {
        this.searchParams.supplierId = event;
        this.querySortingSku();
      },
      // 计算批次数量
      countBatchCount() {
        this.batchCountObj = {};
        for (let i = 0; i < this.packDatas.length; i++) {
          let packItem = this.packDatas[i];
          if (packItem.status <= CONSTANT.DELIVER_STATE_KEY.PACK_COMPLETE) {
            if (packItem.batch_no) {
              if (this.batchCountObj[packItem.batch_no]) {
                let realCount = parseFloat(Number((Number(this.batchCountObj[packItem.batch_no]) + Number(packItem.extend.weight)).toFixed(2)))
                this.$set(this.batchCountObj, packItem.batch_no, realCount)
              } else {
                this.$set(this.batchCountObj, packItem.batch_no, packItem.extend.weight)
              }
            }
          }
        }
      },
    },
    /*computed: {
        sortingEndTime() {
            return this.$store.state.sortingTimeSetting.sortingEndTime
        }
    },
    watch: {
        sortingEndTime(to, old) {
            /!*console.log(11,to)
            console.log(22,old)*!/
            this.querySortingSku();
        }
    },*/
    watch: {
      "$store.state.storeComplete"(to, old) {
        this.searchParams.dateType = this.$store.state.dateType;
        this.searchParams.packTime = [this.$store.state.sortingTimeSetting.sortingStartTime, this.$store.state.sortingTimeSetting.sortingEndTime];
        this.querySortingSku();
      }
    },
    created() {
      if (this.$store.state.storeComplete) {
        this.querySortingSku();
      }
      this.queryCarLine();
      this.getPrintTemplate();
      let openPic = localStorage.getItem("openPic");
      if (openPic) {
        this.openPic = openPic == "true" ? true : false;
      }
    },
    activated() {
      if (this.$store.state.storeComplete) {
        this.querySortingBySku();
        this.$refs.weightReading.showUnitValue();
      }
    }
  }
</script>

<style scoped lang="less">
  .usePageBox {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-top: 50px;
    position: relative;
    box-sizing: border-box;

    .topBox {
      top: 0;
      left: 0;
      width: 100%;
      height: 50px;
      display: flex;
      padding: 0 10px;
      position: absolute;
      align-items: flex-start;

      .leftBox {
        width: 240px;
      }

      .rightBox {
        flex-grow: 1;
        display: flex;
        padding-left: 20px;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
      }
    }

    .contentBox {
      width: 100%;
      height: 100%;
      display: flex;

      .leftBox {
        width: 240px;
      }

      .rightBox {
        flex-grow: 1;
        padding: 0 20px;
        overflow: hidden;
        overflow-y: scroll;
        box-sizing: border-box;
      }

      .rightBox::-webkit-scrollbar {
        width: 30px;
        height: 100%;
        background-color: #f0faff;
      }

      .rightBox::-webkit-scrollbar-thumb {
        border-radius: 6px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background-color: #666666;
      }
    }
  }

  .skuBoxArea {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .skuBoxArea::-webkit-scrollbar {
    display: none;
    height: 100%;
    background-color: #17233d;
  }

  .childContentBox {
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }

  .childContentBox::-webkit-scrollbar {
    display: none;
  }

  .skuBox {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
    background-color: #17233d;
  }

  .skuBox::-webkit-scrollbar {
    width: 30px;
    height: 100%;
    background-color: #f0faff;
  }

  .skuBox::-webkit-scrollbar-thumb {
    border-radius: 6px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #666666;
  }

  .skuItem {
    width: 100%;
    display: flex;
    min-height: 60px;
    color: #F0F0F0;
    padding: 5px 8px;
    align-items: center;
    justify-content: flex-start;

    &:hover {
      color: #F0F0F0;
      background-color: #21345c !important;
    }

    &.active {
      color: #595959;
      border-left: 6px solid #4c70db;
      background-color: #f0faff !important;
    }
  }

  /*.skuItem:hover {
      color: #F0F0F0;
      background-color: #21345c !important;
  }*/

  .countNum {
    display: inline-block;
    margin-left: 6px;
    height: 100%;

    .numtext {
      display: flex;
      height: 20px;
      font-size: 18px;
      line-height: 18px;
      color: #ffffff;
      min-width: 27px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      background-color: #fb4747;
    }
  }

  .cardLeft {
    width: 75%;
    // float: left;
    height: 100%;
    background-color: #6699CC;
    min-height: 150px;
    color: #F0F0F0
  }

  .cardRight {
    top: 0;
    right: 0;
    width: 25%;
    // float: left;
    position: absolute;
    height: 100%;
    min-height: 150px;

    .top {
      // height: 75px;
      height: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px #dedede solid;
      border-radius: 0;
      text-align: center;
      // line-height: 75px;
      width: 75px;
    }

    .buttom {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dedede;
      border-radius: 0;
      border-top: none;
      text-align: center;
      // line-height: 75px;
      width: 75px;
    }
  }

  .areaBox {
    position: relative;
  }

  .footerButton {
    height: 50px;
    padding: 20px;
    margin-left: 6px;
    border-radius: 2px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 1px solid #dedede;

    &.waring {
      color: #FFF;
      background-color: #ff9900;
    }

    &.success {
      color: #FFF;
      background-color: #4c70db;
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/sorting/standardSorting.vue